import { CheckInTagDto } from '@careapp-group/ng-sdk';
import { createSelector } from '@ngrx/store';
import * as actions from '../actions/index';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { CheckInTags } from './check-in-tags.actions';

export interface CheckInTagStateInterface extends DataListState<CheckInTagDto> {
  frequentlyUsedIds: string[];
}

export class CheckInTagsReducer extends ReducerStateFactory<CheckInTagDto> {
  public reducer(
    state: CheckInTagStateInterface = {
      ...INITIAL_DATA_LIST_STATE,
      frequentlyUsedIds: [],
    },
    action: actions.CAAction
  ): CheckInTagStateInterface {
    switch (action.type) {
      case CheckInTags.RESPONSE_SUCCESS_FREQUENTLY_USED:
        return {
          ...state,
          frequentlyUsedIds: action.payload.map((item: any) => item.id),
        };
    }

    return super.reducer(state, action) as any;
  }
}

export const state = new CheckInTagsReducer(actions.CheckInTags);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}

export const createSelectors = (rootReducer: any) => ({
  getFrequentlyUsedIds: createSelector(
    rootReducer,
    (state: CheckInTagStateInterface) => state.frequentlyUsedIds
  ),
});
